var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryParcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6951 11.819L25.5701 4.60025C25.3763 4.49363 25.1587 4.43773 24.9375 4.43773C24.7163 4.43773 24.4986 4.49363 24.3048 4.60025L11.1798 11.819C10.974 11.9323 10.8024 12.0988 10.6829 12.301C10.5634 12.5032 10.5004 12.7338 10.5004 12.9688C10.5004 13.2037 10.5634 13.4343 10.6829 13.6365C10.8024 13.8387 10.974 14.0052 11.1798 14.1185L23.625 20.9632V35.0319L19.6402 32.84L18.375 35.1382L24.3048 38.3997C24.4986 38.5066 24.7162 38.5626 24.9375 38.5626C25.1587 38.5626 25.3764 38.5066 25.5701 38.3997L38.6951 31.181C38.9009 31.0678 39.0726 30.9013 39.1922 30.6991C39.3118 30.4968 39.3749 30.2662 39.375 30.0312V12.9688C39.3749 12.7338 39.3118 12.5032 39.1922 12.3009C39.0726 12.0987 38.9009 11.9322 38.6951 11.819ZM24.9375 7.24888L35.339 12.9688L24.9375 18.6886L14.5359 12.9688L24.9375 7.24888ZM36.75 29.2556L26.25 35.0306V20.9619L36.75 15.1869V29.2556Z",
    fill: "#DBB57C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 21.5H2.625V18.875H13.125V21.5ZM15.75 32H5.25V29.375H15.75V32ZM18.375 26.75H7.875V24.125H18.375V26.75Z",
    fill: "#DBB57C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryParcel);
export default __webpack_public_path__ + "static/media/delivery-parcel.5b4ced100d7251346fc06802ee37190c.svg";
export { ForwardRef as ReactComponent };